// source: legebill/site/membership/v4/membership.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
goog.exportSymbol('proto.legebill.site.membership.v4.Authority', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.GetMembershipRequest', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.ListMembershipsRequest', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.ListMembershipsResponse', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.ListSitePermissionsRequest', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.ListSitePermissionsResponse', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.Membership', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.MembershipStatus', null, global);
goog.exportSymbol('proto.legebill.site.membership.v4.SitePermission', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.GetMembershipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.membership.v4.GetMembershipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.GetMembershipRequest.displayName = 'proto.legebill.site.membership.v4.GetMembershipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.ListMembershipsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.membership.v4.ListMembershipsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.ListMembershipsRequest.displayName = 'proto.legebill.site.membership.v4.ListMembershipsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.ListMembershipsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.membership.v4.ListMembershipsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.membership.v4.ListMembershipsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.ListMembershipsResponse.displayName = 'proto.legebill.site.membership.v4.ListMembershipsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.Membership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.membership.v4.Membership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.Membership.displayName = 'proto.legebill.site.membership.v4.Membership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.membership.v4.ListSitePermissionsRequest.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.membership.v4.ListSitePermissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.ListSitePermissionsRequest.displayName = 'proto.legebill.site.membership.v4.ListSitePermissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.membership.v4.ListSitePermissionsResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.membership.v4.ListSitePermissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.membership.v4.ListSitePermissionsResponse.displayName = 'proto.legebill.site.membership.v4.ListSitePermissionsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.GetMembershipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.GetMembershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.GetMembershipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.GetMembershipRequest}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.GetMembershipRequest;
  return proto.legebill.site.membership.v4.GetMembershipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.GetMembershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.GetMembershipRequest}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.GetMembershipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.GetMembershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.GetMembershipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.GetMembershipRequest} returns this
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.GetMembershipRequest} returns this
 */
proto.legebill.site.membership.v4.GetMembershipRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.ListMembershipsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.ListMembershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.ListMembershipsRequest}
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.ListMembershipsRequest;
  return proto.legebill.site.membership.v4.ListMembershipsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.ListMembershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.ListMembershipsRequest}
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.ListMembershipsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.ListMembershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.ListMembershipsRequest} returns this
 */
proto.legebill.site.membership.v4.ListMembershipsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.ListMembershipsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.ListMembershipsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipsList: jspb.Message.toObjectList(msg.getMembershipsList(),
    proto.legebill.site.membership.v4.Membership.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.ListMembershipsResponse}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.ListMembershipsResponse;
  return proto.legebill.site.membership.v4.ListMembershipsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.ListMembershipsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.ListMembershipsResponse}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.membership.v4.Membership;
      reader.readMessage(value,proto.legebill.site.membership.v4.Membership.deserializeBinaryFromReader);
      msg.addMemberships(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.ListMembershipsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.ListMembershipsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.membership.v4.Membership.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Membership memberships = 1;
 * @return {!Array<!proto.legebill.site.membership.v4.Membership>}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.getMembershipsList = function() {
  return /** @type{!Array<!proto.legebill.site.membership.v4.Membership>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.membership.v4.Membership, 1));
};


/**
 * @param {!Array<!proto.legebill.site.membership.v4.Membership>} value
 * @return {!proto.legebill.site.membership.v4.ListMembershipsResponse} returns this
*/
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.setMembershipsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.membership.v4.Membership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.membership.v4.Membership}
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.addMemberships = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.membership.v4.Membership, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.membership.v4.ListMembershipsResponse} returns this
 */
proto.legebill.site.membership.v4.ListMembershipsResponse.prototype.clearMembershipsList = function() {
  return this.setMembershipsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.Membership.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.Membership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.Membership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.Membership.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    authority: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0),
    email: jspb.Message.getFieldWithDefault(msg, 9, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.Membership}
 */
proto.legebill.site.membership.v4.Membership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.Membership;
  return proto.legebill.site.membership.v4.Membership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.Membership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.Membership}
 */
proto.legebill.site.membership.v4.Membership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {!proto.legebill.site.membership.v4.Authority} */ (reader.readEnum());
      msg.setAuthority(value);
      break;
    case 8:
      var value = /** @type {!proto.legebill.site.membership.v4.MembershipStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.Membership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.Membership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.Membership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.Membership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAuthority();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 5;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string first_name = 6;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_name = 7;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Authority authority = 3;
 * @return {!proto.legebill.site.membership.v4.Authority}
 */
proto.legebill.site.membership.v4.Membership.prototype.getAuthority = function() {
  return /** @type {!proto.legebill.site.membership.v4.Authority} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.legebill.site.membership.v4.Authority} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setAuthority = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional MembershipStatus status = 8;
 * @return {!proto.legebill.site.membership.v4.MembershipStatus}
 */
proto.legebill.site.membership.v4.Membership.prototype.getStatus = function() {
  return /** @type {!proto.legebill.site.membership.v4.MembershipStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.legebill.site.membership.v4.MembershipStatus} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string email = 9;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string external_id = 10;
 * @return {string}
 */
proto.legebill.site.membership.v4.Membership.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.Membership} returns this
 */
proto.legebill.site.membership.v4.Membership.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.ListSitePermissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    permissionsToCheckList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.ListSitePermissionsRequest;
  return proto.legebill.site.membership.v4.ListSitePermissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.legebill.site.membership.v4.SitePermission>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPermissionsToCheck(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.ListSitePermissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPermissionsToCheckList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SitePermission permissions_to_check = 2;
 * @return {!Array<!proto.legebill.site.membership.v4.SitePermission>}
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.getPermissionsToCheckList = function() {
  return /** @type {!Array<!proto.legebill.site.membership.v4.SitePermission>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.legebill.site.membership.v4.SitePermission>} value
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.setPermissionsToCheckList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.legebill.site.membership.v4.SitePermission} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.addPermissionsToCheck = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsRequest} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsRequest.prototype.clearPermissionsToCheckList = function() {
  return this.setPermissionsToCheckList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.membership.v4.ListSitePermissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitePermissionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsResponse}
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.membership.v4.ListSitePermissionsResponse;
  return proto.legebill.site.membership.v4.ListSitePermissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsResponse}
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.legebill.site.membership.v4.SitePermission>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSitePermissions(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.membership.v4.ListSitePermissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitePermissionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated SitePermission site_permissions = 1;
 * @return {!Array<!proto.legebill.site.membership.v4.SitePermission>}
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.getSitePermissionsList = function() {
  return /** @type {!Array<!proto.legebill.site.membership.v4.SitePermission>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.legebill.site.membership.v4.SitePermission>} value
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.setSitePermissionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.legebill.site.membership.v4.SitePermission} value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.addSitePermissions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.membership.v4.ListSitePermissionsResponse} returns this
 */
proto.legebill.site.membership.v4.ListSitePermissionsResponse.prototype.clearSitePermissionsList = function() {
  return this.setSitePermissionsList([]);
};


/**
 * @enum {number}
 */
proto.legebill.site.membership.v4.Authority = {
  AUTHORITY_UNSPECIFIED: 0,
  MEMBER: 1,
  USER_ADMIN: 5,
  MANAGER: 2,
  OWNER: 3
};

/**
 * @enum {number}
 */
proto.legebill.site.membership.v4.MembershipStatus = {
  MEMBERSHIP_STATUS_UNSPECIFIED: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  ANONYMIZED: 3,
  ACCOUNT_DELETED: 4
};

/**
 * @enum {number}
 */
proto.legebill.site.membership.v4.SitePermission = {
  SITE_PERMISSION_UNSPECIFIED: 0,
  POST_TIME: 1,
  POST_ASSOCIATED_TIME: 2,
  VIEW_REPORTS: 3,
  VIEW_DASHBOARD: 5,
  EDIT_SITE_MEMBERSHIPS: 6,
  EDIT_SITE_SETTINGS: 7,
  MANAGE_TAGS: 8,
  VIEW_TRENDS_OWN: 9,
  VIEW_TRENDS_OTHERS: 10,
  MANAGE_POST_EXPECTATION: 11
};

goog.object.extend(exports, proto.legebill.site.membership.v4);
